import type { Theme } from '@mui/material';

export const styles = {
  frame: {
    position: 'relative',
    height: '100%',
    containerType: 'inline-size',
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: '4rem',
    paddingBlock: '1rem',
    paddingInline: '1.5rem',
  },

  headerActions: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  }),

  footer: (theme: Theme) => ({
    minHeight: '3.5rem',
    borderTop: 'solid 1px',
    borderTopColor: theme.colors.neutral[200],
  }),

  downloadButton: (theme: Theme) => ({
    color: theme.colors.primary[500],
    background: theme.colors.primary[50],
    padding: theme.spacing(0.5),
    borderRadius: theme.spacing(0.5),

    '&:hover, &:hover:not(:disabled)': {
      background: theme.colors.primary[100],
    },
  }),

  icon: (theme: Theme) => ({
    color: theme.colors.neutral[600],
    background: theme.colors.neutral[50],
    borderRadius: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    px: theme.spacing(1.5),
    py: theme.spacing(0.75),
  }),

  iconText: {
    display: 'inline-block',

    // full support for container queries is only available in MUI v6
    '@container (max-width: 700px)': {
      display: 'none',
    },
  },
};
